import React from 'react';
import ClinicSurvey from './ClinicSurvey';

function SurveyTab() {
    return <ClinicSurvey />;
}

export default SurveyTab;
